// pages/environment.js

export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const Jobs_API = `${BASE_URL}/jobs`;
export const Login_API = `${BASE_URL}/auth/login`;
export const Applications_API = `${BASE_URL}/applications`;
export const Applications_Filter_API = `${BASE_URL}/applications/filter`;
export const Admin_API = `${BASE_URL}/admin`;
export const Hr_API = `${BASE_URL}/hr`;
export const Category_API = `${BASE_URL}/categories`;
export const ResumeUpload_API = `${BASE_URL}/resume/upload`;
export const ResumeDelete_API = `${BASE_URL}/resume/delete`;
export const Career_Subscribers_API = `${BASE_URL}/career-subscribers`;
export const Blog_Subscribers_API = `${BASE_URL}/subscribers`;
export const News_API = `${BASE_URL}/news`;
export const Blogs_API = `${BASE_URL}/blogs`;
export const BlogTopic_API = `${BASE_URL}/blog_topics`;
export const Authors_API = `${BASE_URL}/authors`;
export const BlogContent_API = `${BASE_URL}/blog_content`;
export const BlogTemplate_API = `${BASE_URL}/templates`;
export const ContactUs_API = `${BASE_URL}/contactus`;
export const ImageUpload_API = `${BASE_URL}/image/upload`;
export const ImageDelete_API = `${BASE_URL}/image/delete`;

export const EmailServiceConfig = `${BASE_URL}/email-service-config`;
